export default {
    cart(state) {
        return state.cart;
    },
    kits(state) {
        return state.kits;
    },
    totals(state) {
        return state.totals;
    },
    email(state) {
        return state.email;
    },
    phone(state) {
        return state.phone;
    },
    carrier(state) {
        return state.carrier;
    },
    shippingdetails(state) {
        return {
            "shippingname": state.shippingname,
            "shippingaddress1": state.shippingaddress1,
            "shippingaddress2": state.shippingaddress2,
            "shippingcity": state.shippingcity,
            "shippingstate": state.shippingstate,
            "shippingcountry": state.shippingcountry,
            "shippingzip": state.shippingzip,
            "shippingphone": state.shippingphone
        }
    },
    billingdetails(state) {
        return {
            "billingname": state.billingname,
            "billingaddress1": state.billingaddress1,
            "billingaddress2": state.billingaddress2,
            "billingcity": state.billingcity,
            "billingstate": state.billingstate,
            "billingcountry": state.billingcountry,
            "billingzip": state.billingzip,
            "billingphone": state.billingphone
        }
    },
    ordernotes(state) {
        return state.ordernotes;
    },
    paymenttype(state) {
        return state.paymenttype;
    },
    purchaseorder(state) {
        return state.purchaseorder;
    },
    ordernumber(state) {
        return state.ordernumber;
    },
    orderdate(state) {
        return state.orderdate;
    },
    paymentmethod(state) {
        return state.paymentmethod;
    },
    promocode(state) {
        return state.promocode;
    },

    order_notes(state){
        return state.order_notes;
    },

    cc_details(state){
        return {
            cc_token: state.cc_token,
            cc_number: state.cc_number,
            cc_fname: state.cc_fname,
            cc_lname: state.cc_lname,
            cc_cvv: state.cc_cvv,
            cc_exp_mo: state.cc_exp_mo,
            cc_exp_yr: state.cc_exp_yr,
            cc_address: state.cc_address,
            cc_city: state.cc_city,
            cc_state: state.cc_state,
            cc_zip: state.cc_zip,
            cc_country: state.cc_country,
            cc_saved_id: state.cc_saved_id,
            to_save_new_cc: state.to_save_new_cc
        }
    },

    cust_location(state){
        return state.cust_location
    },

    tax_rate(state) {
        return state.tax_rate;
    },

    shippingDifferent(state){
        return state.shippingDifferent;
    },

    po_required(state){
        return state.po_required;
    },

    cart_expiration(state){
        return state.cart_expiration;
    },
    
    ordered_items(state){
        return state.ordered_items;
    },

    backordered_items(state){
        return state.backordered_items;
    },

    promo_code(state){
        return state.promo_code;
    },

    cedkoe(state){
        return state.cedkoe;
    },
}